import React from 'react';
import PropTypes from 'prop-types';
import mediator, { ACTIONS } from 'mediator';
import svgClasses from '../lib/common/svgClasses';
import fetcher from '../lib/common/fetcher';

const LevelIndicator = React.createClass({
  propTypes: {
    selectedLevel: PropTypes.object,
    svgData: PropTypes.string,
    levels: PropTypes.arrayOf(PropTypes.object),
    isAvailable: PropTypes.bool // eslint-disable-line react/no-unused-prop-types
  },
  getInitialState: function() {
    return {
      selectedLevel: this.props.selectedLevel
        ? this.props.selectedLevel.selector
        : null
    };
  },
  componentDidMount: function() {
    this.fetchLevelIndicatorSVG();
    mediator.subscribe(ACTIONS.LEVEL_SELECTED, level => {
      this.setState({ selectedLevel: level });
    });
  },
  componentDidUpdate: function(prevProps, prevState) {
    mediator.subscribe(ACTIONS.LEVEL_SELECTED, level => {
      this.setState({ selectedLevel: level });
    });

    let selectedLevel = this.state.selectedLevel;
    if (prevState.selectedLevel !== selectedLevel) {
      return this.enhanceLevelIndicator(selectedLevel);
    }

    if (this._levelIndicatorPaths) {
      this.handleClickOnPath();
    }
  },
  handleClickOnPath: function() {
    this._levelIndicatorPaths.forEach(el => {
      el.onclick = () => mediator.publish(ACTIONS.LEVEL_PRESELECTED, el.id);
    });
  },
  enhanceLevelIndicator: function(selectedLevel) {
    this.props.levels.forEach((level, idx) => {
      if (selectedLevel === level.el.id) {
        svgClasses.addClass(
          this._levelIndicatorSvg.children[idx],
          'syos-level-indicator--active'
        );
      } else {
        svgClasses.removeClass(
          this._levelIndicatorSvg.children[idx],
          'syos-level-indicator--active'
        );
      }
    });
  },
  fetchLevelIndicatorSVG: function() {
    if (this.props.currentFacility) {
      const currentFacility = this.props.currentFacility;

      fetcher.fetchHtml(currentFacility.levelMapping.svg).then(svgData => {
        this.setState({
          svgData: svgData
        });

        return svgData;
      });
    }
  },
  render: function() {
    return this.props.levels.length &&
    this.state.svgData &&
    this.props.currentFacility.levelMapping.enabled ? (
      <div className="syos-level-indicator">
        <p>
          <strong>Current level</strong>
        </p>
        <div
          className="syos-level-indicator--svg"
          ref={node => {
            this._levelIndicatorSvg = node && node.querySelector('svg');
            this._levelIndicatorPaths =
              node && node.querySelectorAll('svg path');
          }}
          dangerouslySetInnerHTML={{
            __html: this.state.svgData
          }}
        />
      </div>
    ) : null;
  }
});

export default LevelIndicator;



// WEBPACK FOOTER //
// ./src/javascripts/app/components/LevelIndicator.js